import { useEffect, useRef, useState } from 'react';
import { collection, getDocs, orderBy, query } from 'firebase/firestore';
import { toast } from 'react-toastify';
import { db } from '../../../config/firebaseConfig';
import { useTranslation } from '../../../i18n/LanguageContext';

/** Departments and authorization roles for the employee forms (DataEntryValues). */
const useEmployeeFormOptions = () => {
  const { t } = useTranslation();
  const tRef = useRef(t);
  tRef.current = t;
  const [departments, setDepartments] = useState([]);
  const [authorizationRoles, setAuthorizationRoles] = useState([]);
  const [isLoadingDepartments, setIsLoadingDepartments] = useState(true);
  const [isLoadingAuthorizationRoles, setIsLoadingAuthorizationRoles] = useState(true);

  useEffect(() => {
    // Fetch departments from Firestore
    const fetchDepartments = async () => {
      try {
        setIsLoadingDepartments(true);
        const employeeDepartmentsRef = collection(db, 'DataEntryValues', 'departments', 'EmployeeDepartments');
        const q = query(employeeDepartmentsRef, orderBy('id', 'asc'));
        const querySnapshot = await getDocs(q);
        setDepartments(querySnapshot.docs.map(doc => doc.data().value));
      } catch (error) {
        console.error('Error fetching departments:', error);
        toast.error(tRef.current('employees.form.departmentsError'));
      } finally {
        setIsLoadingDepartments(false);
      }
    };

    // Fetch authorization roles from Firestore
    const fetchAuthorizationRoles = async () => {
      try {
        setIsLoadingAuthorizationRoles(true);
        const authorizationRolesRef = collection(db, 'DataEntryValues', 'roles', 'AuthorizationRoles');
        const q = query(authorizationRolesRef, orderBy('id', 'asc'));
        const querySnapshot = await getDocs(q);
        setAuthorizationRoles(querySnapshot.docs.map(doc => doc.data().value));
      } catch (error) {
        console.error('Error fetching authorization roles:', error);
        toast.error(tRef.current('employees.form.rolesError'));
      } finally {
        setIsLoadingAuthorizationRoles(false);
      }
    };

    fetchDepartments();
    fetchAuthorizationRoles();
  }, []);

  return { departments, authorizationRoles, isLoadingDepartments, isLoadingAuthorizationRoles };
};

export default useEmployeeFormOptions;
